export default __webpack_public_path__ + "static/media/330_dummy2016-schauspieler01-mobile-de.a4714a36.png";